import * as Sentry from "@sentry/react";

// A public_key vai SEM hífens: a regex de DSN do Sentry SDK valida a key como \w+,
// que não aceita hífen. Com hífens o SDK loga "Invalid Sentry Dsn" e não envia nada.
const GLITCHTIP_DSN =
  "https://d08ec75f67fd4deb8186b92f0e914021@adm.graficakr.com.br/glitchtip/1";

export function initSentry() {
  if (process.env.NODE_ENV !== "production") return;

  Sentry.init({
    dsn: GLITCHTIP_DSN,
    // Captura apenas 20% dos erros para não sobrecarregar (ajuste se necessário)
    tracesSampleRate: 0.2,
    // Ignora erros de extensões de browser e erros de rede esperados
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "Non-Error promise rejection captured",
      /^Network Error$/,
      /^Request failed with status code 401$/,
      /^Request failed with status code 403$/,
    ],
    beforeSend(event) {
      // Não envia erros gerados por extensões do browser
      const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? [];
      if (frames.some(f => f.filename?.includes("extension://"))) return null;
      // Strip Authorization e cookies para não vazar tokens JWT
      if (event.request?.headers) {
        delete event.request.headers["Authorization"];
        delete event.request.headers["authorization"];
        delete event.request.headers["Cookie"];
        delete event.request.headers["cookie"];
      }
      return event;
    },
  });
}
